
export default t => {
  return t < .5 ? Math.cbrt(t / 4) : (2 - Math.cbrt(2 - 2 * t)) / 2
}
